import React from 'react';
import glamorous from 'glamorous';

const Scope = () => {
  return (
    <div>
      <h3>
        SCOPE OF THIS GUIDE
      </h3>
      <p>
        This guide describes how to prepare recalls in order to load them into the OECD <i>GlobalRecalls</i> portal (<a
        href="http://globalrecalls.oecd.org" target="_blank">http://globalrecalls.oecd.org</a>).
        The portal is an online tool that contains regularly-updated information from the OECD and
        non-OECD economies on mandatory and voluntary consumer product recalls issued around the world.
      </p>
      <br/>
      <div>
        The document explains how to:
        <glamorous.Ul
          className="pt-list"
          css={{
            listStyle: 'disc',
          }}
        >
          <li>import new recalls into the portal</li>
          <li>modify existing recalls available on the portal</li>
          <li>delete existing recalls from the portal.</li>
        </glamorous.Ul>
      </div>
      <br/>
      <div>
        The guide also outlines the process for uploading recalls, both manually and automatically, through the use of
        an Application Programming Interface (API) by a server.
      </div>
      <br/>
      <p>
        In order to publish recalls onto the portal, each recall <strong>MUST</strong> be prepared in an XML file, under
        a specific
        structure (described further in this guide) before it is uploaded into the portal.
      </p>
      <p>
        Separate XML files <strong>MUST</strong> be created in order to insert a new recall, and update or delete an
        existing recall in the
        portal.
      </p>
    </div>
  );
};

export default Scope;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/scope.js